import { BudgetPositionsSetsPage } from "@components/modules/budgets/positions-sets";
import { NavigationProposals } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { FullScreenContainer } from "@src/components/ui-kit";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => {
  return (
    <MainLayout
      fullWidth
      title={t`Budgets`}
      navigation={<NavigationProposals />}
    >
      <FullScreenContainer noBottomMargin>
        <BudgetPositionsSetsPage />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/hourly-rates")({
  component: Page,
});
